import React from "react";
import { Box, Container, Grid } from "@mui/material";
import AccommodationFilters from "./AccommodationFilters";
import AccommodationList from "./AccommodationList";
import MapView from "./MapView";

const AccommodationPage = () => {
  return (
    <Box>
      <Container maxWidth="xl" sx={{ py: 4 }}>
        <AccommodationFilters />
        <Grid container spacing={3} sx={{ mt: 3 }}>
          <Grid size={{ xs: 12, md: 6, lg: 5 }}>
            <AccommodationList />
          </Grid>
          <Grid size={{ xs: 12, md: 6, lg: 7 }}>
            <MapView />
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default AccommodationPage;
